import React from 'react'
import { useSelector } from 'react-redux';
import clsx from 'clsx';
// material ui
import { makeStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
// components
import Theme from '../../Theme.js';
import WidgetBar from '../../../../builder/components/WidgetBar.js'
// helpers
import { getMessage } from '../helpers.js';

const useStyles = makeStyles({
  actions: {
    // justifyContent: 'space-evenly',
    padding: '0',
    justifyContent: 'space-between',
    '&:before': {
      content: '""',
      display: 'block',
    },
    '&:after': {
      content: '""',
      display: 'block',
    },
  },
  avatar: {
    width: '100px',
    height: '100px',
    border: '2px solid ' + Theme.bgColorLight,
    boxShadow: Theme.avatarBoxShadow,
  },
  card: {
    boxShadow: Theme.cardBoxShadow,
    marginBottom: '28px',
    padding: '12px 12px 18px',
    position: 'relative',
  },
  gm: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: '100px',
    textAlign: 'center',
  },
  gmName: {
    fontSize: '1.25rem',
  },
  guideTitle: {
    textTransform: 'uppercase',
  },
  header: {
      alignItems: 'center',
      display: 'flex',
      position: 'relative',
      padding: '0 0 12px',
  },
  text: {
    alignItems: 'center',
    display: 'flex',
    flex: '1',
    backgroundColor: Theme.bgColorDark,
    marginLeft: '-30px',
    marginRight: '-12px',
    padding: '12px 12px 12px 42px',
  },
  gmText: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'left',
    flex: '1',
  },
  body: {
    margin: '0 auto',
    maxWidth: '400px',
    padding: '0 16px 16px',
    width: '100%',
  },
  tipJar: {
    width: '33px',
  }
});

export default function TipJar(props) {
  const [showWidgetBar, setShowWidgetBar] = React.useState(false)
  const { context, screen } = props;
  console.log('context:', context)
  let avatarSize = 120;
  const styleProps = {
    "avatarSize": avatarSize,
    "headerPadding": 16,
    "screen": screen,
  }
  const classes = useStyles(styleProps);
  var order;
  (screen == 'desktop') ? (order = context.desktop_order) : (order = context.mobile_order);
  const componentClasses = clsx({
    [classes.card] : true,
    "cardMobile" : screen == 'mobile' ? true : false,
  })

  var msgHeader;
  var msgText;
  if (window.mode == 'live') {
    var language = window.language;
    msgHeader = context.message_title;
    msgText = context.message_body;
  } else {
    var activeRoom = useSelector(state => state.activeRoom);
    var didEscape = useSelector(state => state.didEscape);
    var groupType = useSelector(state => state.groupType);
    var language = useSelector(state => state.language);
    var roomMessaging = useSelector(state => state.roomMessaging);
    msgHeader = getMessage("msg_title", didEscape, activeRoom, groupType, roomMessaging, language);
    msgText = getMessage("msg_body", didEscape, activeRoom, groupType, roomMessaging, language);
  }

  const handleWidgetHover = (e) => {
    if (e.type == 'mouseenter') {
      setShowWidgetBar(true);
    } else if (e.type == 'mouseleave') {
      setShowWidgetBar(false);
    }
  }

  return (
    <>
    {context.author_image && context.button_link &&
      <Card className={componentClasses} style={{ order: order }}
        onMouseEnter={window.mode == 'builder' ? handleWidgetHover : null} onMouseLeave={window.mode == 'builder' ? handleWidgetHover : null}
      >

        <CardContent className={classes.header} >
          <div className={classes.gm}>
            <Avatar src={context.author_image} className={classes.avatar} />
          </div>
          <div className={classes.text}>
            <div className={classes.gmText}>
              <Typography variant="h5" component="h2" className={classes.gmName}>
                {context.author_name}
              </Typography>
              <Typography variant="caption" component="p" color="textSecondary" className={classes.guideTitle}>
                {context.guide_title[language] || context.guide_title["en"]}
              </Typography>
            </div>
            <div className={classes.tipJar}>
              <img alt="Tip Jar" style={{ width: '100%' }} src="https://socialwaiver-assets.s3.us-east-2.amazonaws.com/static/images/builder/tip-jar.png" />
            </div>
          </div>
        </CardContent>

        <CardContent className={classes.body} >
          <Typography gutterBottom variant="body1" component="h2" style={{ whiteSpace: 'pre-line' }} >
            {context.header[language]}
          </Typography>
          <Typography variant="body2" color="textSecondary" component="p" style={{ whiteSpace: 'pre-line' }} >
            {context.subheader[language]}
          </Typography>
        </CardContent>

        <CardActions className={classes.actions} >
          <Button variant="outlined" size="large" color="primary"
            target="_blank" rel="noopener" href={context["button_link"]}
          >
            {context.button_text[language] || context.button_text["en"]}
          </Button>
        </CardActions>

        {window.mode == 'builder' && showWidgetBar &&
          <WidgetBar context={context} />
        }

      </Card>
    }
    </>
  )
}